/**
 * Navbar Component
 */
import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Navbar.css';

const NAV_LINKS = [
  { path: '/algorithms', label: 'Algorithms' },
  { path: '/problems', label: 'Problems' },
  { path: '/categories', label: 'Categories' },
  { path: '/compare', label: 'Compare' },
];

function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  // Close mobile menu on route change
  useEffect(() => setMobileOpen(false), [location]);

  return (
    <nav className={`navbar ${scrolled ? 'scrolled' : ''}`}>
      <div className="navbar-inner">
        {/* Logo */}
        <Link to="/" className="navbar-logo">
          <span className="logo-icon">⚡</span>
          <span className="logo-text">
            Algo<span className="logo-accent">Solve</span>
          </span>
        </Link>

        {/* Desktop links */}
        <ul className="navbar-links">
          {NAV_LINKS.map(({ path, label }) => (
            <li key={path}>
              <Link
                to={path}
                className={`nav-link ${location.pathname.startsWith(path) ? 'active' : ''}`}
              >
                {label}
              </Link>
            </li>
          ))}
        </ul>

        {/* CTA */}
        <div className="navbar-cta">
          <Link to="/problems" className="btn btn-primary btn-sm">
            Start Solving →
          </Link>
        </div>

        {/* Mobile hamburger */}
        <button
          className={`hamburger ${mobileOpen ? 'open' : ''}`}
          onClick={() => setMobileOpen(!mobileOpen)}
          aria-label="Toggle menu"
        >
          <span /><span /><span />
        </button>
      </div>

      {/* Mobile menu */}
      <div className={`mobile-menu ${mobileOpen ? 'open' : ''}`}>
        {NAV_LINKS.map(({ path, label }) => (
          <Link
            key={path}
            to={path}
            className={`mobile-link ${location.pathname.startsWith(path) ? 'active' : ''}`}
          >
            {label}
          </Link>
        ))}
        <Link to="/problems" className="btn btn-primary w-full" style={{ marginTop: 12 }}>
          Start Solving →
        </Link>
      </div>
    </nav>
  );
}

export default Navbar;
